<template>
  <div class="about">
    <Header :imgUrl="require('@/assets/img/mission/01-sm.jpg')">
      <h1>¿Quiénes somos?</h1>
      <a
        class="primary-btn animated fadeIn delay-1s"
        href="#"
        v-scroll-to="{ el: '#content', offset: -90 }"
        >Ver Detalle</a
      >
    </Header>

    <div class="about__content" id="content">
      
      <section class="flex gap-2">
        <img class="about__text-image" :src="require('@/assets/img/quienes-somos.png')" />

        <section class="flex direction-column gap-1">
          <h2 class="about__headline full-width">¿Quiénes somos?</h2>
          
          <p class="about__text-content">
            <span>
              Somos la Fundación Zenobia Barliza, creada en 2009, por un grupo de personas unidas por el sentido de pertenencia regional y anhelos de que todos llevemos una vida digna. En principio, decidimos organizarnos en una fundación sin fines de lucro para trabajar por el cambio, la reducción de los altos índices de pobreza y la inclusión de las comunidades indígenas del Departamento de La Guajira y Colombia. 
            </span>
            <span>
              En el año 2018, recibimos población venezolana que debido a la situación del país hermano, se fue incrementando.
              Para el 2019, el 40% de la población beneficiada eran venezolanos; razón por la cual, incluimos a la población migrante y retornada. El nombre, hace reconocimiento a una mujer del Clan Epieyu, oriunda del Cabo de la Vela (La Guajira) que, por su vocación de servicio, sensibilidad, responsabilidad y liderazgo, fue reconocida como máxima autoridad de la comunidad Wayuu y Arijuna del territorio desde los años veinte hasta los cuarenta del siglo XX.
            </span>
            <span>
              En este orden de ideas, la FZB desarrolla proyectos para la mejora y mantenimiento de la calidad de vida de familias colombianas y migrantes con el fin de contribuir en el crecimiento personal, intelectual, emocional y social de las familias; formando por medio del arte y el respeto de la individualidad, a personas cultas y capaces de utilizar las competencias adquiridas para transformar su propia realidad social, bajo el cumplimiento de sus proyectos de vida.
            </span>
          </p>

          <h3>Misión</h3>
          <p class="about__text-content">
            En la Fundación Zenobia Barliza tenemos como misión, 
            respaldar la creación de una sociedad más justa, 
            equitativa e innovadora mediante la implementación y ejecución de acciones, 
            proyectos y programas que rescaten las tradiciones artísticas y culturales, 
            la protección de la ecología y sostenibilidad ambiental para contribuir al desarrollo humano de las familias vulnerables en Colombia, 
            los refugiados y/o migrantes, generando un impacto positivo en su calidad de vida, 
            promoviendo el crecimiento personal tanto a nivel individual como colectivo.
          </p>

          <h3>Visión</h3>
          <p class="about__text-content">
            Para el año 2030, la Fundación Zenobia Barliza, 
            se proyecta ser una organización social sin ánimo de lucro dinámica y participativa con proyección nacional e internacional, 
            comprometida con la transformación de la sociedad a partir del arte, la cultura y el cuidado del medio ambiente; 
            especialmente en comunidades colombianas vulnerables, refugiadas y/o migrantes sin capacidad para satisfacer sus necesidades y derechos fundamentales.
          </p>

          <h3>Propósito</h3>
          <p class="about__text-content">
            Con arte y pasión aportamos al desarrollo humano de individuos y familias vulnerables, 
            formando personas cultas, visionarias y productivas para la sociedad.
          </p>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  name: "Mision",
  components: {
    Header
  },

  title() {
    return "Quiénes Somos";
  },
};
</script>

<style lang="scss" scoped>
.about {
  $root: &;

  &__content {
    width: 100%;
    max-width: 1024px;
    padding: 2rem 1rem;
    margin: 4rem auto;
    position: relative;
  }

  &__headline {
    padding: 0;
    font-size: 2.5rem;
  }

  &__text-content {
    line-height: 1.8;

    span {
      display: block;
      margin: 1rem 0;
    }
  }

  @media(max-width: 1024px) {
    #{$root}__text-image {
      position: absolute;
      top: 50%;
      left: 50%;
      opacity: .1;
      z-index: -1;
      transform: translate(-50%, -50%);
    }
  }

  @media(min-width: 1024px) {
    #{$root}__text-image {
      height: 100%;
    }
  }
}
</style>
